import { RouteView, PageView } from '../layouts'

export const community = {
    path: '/community',
    name: 'BaseForm',
    component: PageView,
    meta: { title: '社区管理', icon: 'team', isMenuShow: true, permission: 'com' },
    children: [
        {
            path: '/community/management',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/userAuth/list',
            meta: { title: '社交权限管理', icon: 'dollar', isMenuShow: true, permission: 'com:socialauth' },
            children: [
                {
                    path: '/community/userAuth/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/socialContact.vue'),
                    meta: { title: '用户权限列表', icon: 'dollar', isMenuShow: true, permission: 'com:socialauth:userauth' },
                },
                {
                    path: '/community/socialContact/edit',
                    name: 'BaseForm',
                    component: () => import('../views/community/editSocialContact.vue'),
                    meta: { title: '编辑用户权限', icon: 'dollar', isMenuShow: true, permission: 'com:socialauth:userauth' },
                },
                {
                    path: '/community/blackFans/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/blackFansList.vue'),
                    meta: { title: '黑粉列表', icon: 'dollar', isMenuShow: true, permission: 'com:socialauth:blackfans' },
                }

            ]
        },
        {
            path: '/community/content',
            name: 'BaseForm',
            redirect: '/community/content/allinvitations',
            component: PageView,
            meta: { title: '帖子管理', keepAlive: false, isMenuShow: true, permission: 'com:postmanag' },
            children: [
                {
                    path: '/community/content/allinvitations',
                    name: 'BaseForm',
                    component: () => import('../views/community/allinvitations.vue'),
                    meta: { title: '帖子管理', keepAlive: false, isMenuShow: true, permission: 'com:postmanag' },
                },
                {
                    path: '/community/content/addPost',
                    name: 'BaseForm',
                    component: () => import('../views/community/addPost.vue'),
                    meta: { title: '新增九宫格帖子', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:all:add' },
                },
                {
                    path: '/community/content/addPostMixed',
                    name: 'BaseForm',
                    component: () => import('../views/community/addPostMixed.vue'),
                    meta: { title: '新增图文混排帖子', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:all:add' },
                },

                {
                    path: '/community/pendingLisr/pending',
                    name: 'BaseForm',
                    component: () => import('../views/community/pending.vue'),
                    meta: { title: '待审核列表审核', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:waitaudit:audit' },
                },
                {
                    path: '/community/officalList/detail',
                    name: 'BaseForm',
                    component: () => import('../views/community/officalListDetail.vue'),
                    meta: { title: '官宣列表详情', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:offical:detail' },
                },
                {
                    path: '/community/hotList/detail',
                    name: 'BaseForm',
                    component: () => import('../views/community/hotListDetail.vue'),
                    meta: { title: '热门列表详情', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:hot:detail' },
                },
                {
                    path: '/community/allPostList/detail',
                    name: 'BaseForm',
                    component: () => import('../views/community/allPostDetail.vue'),
                    meta: { title: '全部帖子详情', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:all:detail' },
                },
                {
                    path: '/community/allPostList/edit',
                    name: 'BaseForm',
                    component: () => import('../views/community/editPostDetail.vue'),
                    meta: { title: '帖子编辑', icon: 'dollar', isMenuShow: true, permission: 'com:postmanag:all:edit' },
                },
            ]
        },
        {
            path: '/community/sensitive',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/sensitiveWords/list',
            meta: { title: '敏感词库', icon: 'dollar', isMenuShow: true, permission: 'com:sens' },
            children: [
                {
                    path: '/community/sensitiveWords/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/words.vue'),
                    meta: { title: '敏感词库', icon: 'dollar', isMenuShow: true, permission: 'com:sens:senstive' },
                },
                {
                    path: '/community/complainWords/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/complainWords.vue'),
                    meta: { title: '抱怨词库', icon: 'dollar', isMenuShow: true, permission: 'com:sens:complain' },
                },
                {
                    path: '/community/saleWords/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/saleWords.vue'),
                    meta: { title: '销售词库', icon: 'dollar', isMenuShow: true, permission: 'com:sens:sale' },
                },
                {
                    path: '/community/addSensitive',
                    name: 'BaseForm',
                    component: () => import('../views/community/addSensitive.vue'),
                    meta: { title: '添加关键字', icon: 'dollar', isMenuShow: true, permission: 'com:sens:senstive:add' },
                }
            ]
        },

        {
            path: '/community/video',
            name: 'BaseForm',
            redirect: '/community/video/videoManagement',
            component: PageView,
            meta: { title: '视频管理', keepAlive: false, isMenuShow: true, permission: 'com:video' },
            children: [
                {
                    path: '/community/video/videoManagement',
                    name: 'BaseForm',
                    component: () => import('../views/community/videoManagement.vue'),
                    meta: { title: '视频管理', icon: 'dollar', isMenuShow: true, permission: 'com:video' },
                },
                {
                    path: '/community/video/addVideo',
                    name: 'BaseForm',
                    component: () => import('../views/community/addVideo.vue'),
                    meta: { title: '添加视频', icon: 'dollar', isMenuShow: true, permission: 'com:video:add' },
                }
            ]
        },

        {
            path: '/community/recommend/list',
            name: 'BaseForm',
            component: () => import('../views/community/recommend.vue'),
            meta: { title: '推荐管理', icon: 'dollar', isMenuShow: true, permission: 'com:rec' },
        },
        {
            path: '/community/topicManagement',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/topicManagement/list',
            meta: { title: '话题管理', icon: 'dollar', isMenuShow: true, permission: 'com:topic' },
            children: [
                {
                    path: '/community/topicManagement/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/topicManagement.vue'),
                    meta: { title: '话题管理', icon: 'dollar', isMenuShow: true, permission: 'com:topic' },
                },
                {
                    path: '/community/topicManagement/userDetails',
                    name: 'BaseForm',
                    component: () => import('../views/community/userDetails.vue'),
                    meta: { title: '用户明细', icon: 'dollar', isMenuShow: true, permission: 'com:topic:detail' },
                }
            ]
        },
        {
            path: '/community/comment',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/commentManagment/list',
            meta: { title: '评论管理', icon: 'dollar', isMenuShow: true, permission: 'com:comment' },
            children: [
                {
                    path: '/community/commentManagment/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/comment.vue'),
                    meta: { title: '评论管理', icon: 'dollar', isMenuShow: true, permission: 'com:comment' },
                },
                {
                    path: '/community/commentManagment/detail',
                    name: 'BaseForm',
                    component: () => import('../views/community/commentDetail.vue'),
                    meta: { title: '评论详情', icon: 'dollar', isMenuShow: true, permission: 'com:comment:all:detail' },
                },
                {
                    path: '/community/commentReview/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/commentReview.vue'),
                    meta: { title: '待审核列表', icon: 'dollar', isMenuShow: true, permission: 'com:comment:waitaudit' },
                }
            ]
        },
        {
            path: '/community/report',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/reportManagment/list',
            meta: { title: '举报管理', icon: 'dollar', isMenuShow: true, permission: 'com:report' },
            children: [
                {
                    path: '/community/reportManagment/list',
                    name: 'BaseForm',
                    component: () => import('../views/community/reportList.vue'),
                    meta: { title: '举报处理', icon: 'dollar', isMenuShow: true, permission: 'com:report' },
                },
                {
                    path: '/community/reportManagment/detail',
                    name: 'BaseForm',
                    component: () => import('../views/community/reportReview.vue'),
                    meta: { title: '举报审核', icon: 'dollar', isMenuShow: true, permission: 'com:report:audit' },
                }
            ]
        },
        {
            path: '/community/recycle',
            name: 'BaseForm',
            component: PageView,
            redirect: '/community/recycle/post',
            meta: { title: '回收站', icon: 'dollar', isMenuShow: true, permission: 'com:recycle' },
            children: [
                {
                    path: '/community/recycle/post',
                    name: 'BaseForm',
                    component: () => import('../views/community/recycle.vue'),
                    meta: { title: '回收站（帖子）', icon: 'dollar', isMenuShow: true, permission: 'com:recycle:post' },
                },
                {
                    path: '/community/recycle/postDetail',
                    name: 'BaseForm',
                    component: () => import('../views/community/recyclePostDetail.vue'),
                    meta: { title: '回收站（帖子详情）', icon: 'dollar', isMenuShow: true, permission: 'com:recycle:post:detail' },
                },
                {
                    path: '/community/recycle/commentDetail',
                    name: 'BaseForm',
                    component: () => import('../views/community/recycleCommentDetail.vue'),
                    meta: { title: '回收站（评论详情）', icon: 'dollar', isMenuShow: true, permission: 'com:recycle:comment:detail' },
                },
                {
                    path: '/community/recycle/comment',
                    name: 'BaseForm',
                    component: () => import('../views/community/recycleComment.vue'),
                    meta: { title: '回收站（评论）', icon: 'dollar', isMenuShow: true, permission: 'com:recycle:comment' },
                }
                // {
                //     path: '/community/recycle/video',
                //     name: 'BaseForm',
                //     component: () => import('../views/community/recycleVideo.vue'),
                //     meta: {title: '回收站（视频）', icon: 'dollar', isMenuShow: true,permission:''},
                // },
                // {
                //     path: '/community/recycle/words',
                //     name: 'BaseForm',
                //     component: () => import('../views/community/recycleWords.vue'),
                //     meta: {title: '回收站（词库）', icon: 'dollar', isMenuShow: true,permission:''},
                // }
            ]
        },
        {
            path: '/community/carForum/list',
            name: 'BaseForm',
            component: () => import('../views/community/forumDir/carForumList'),
            meta: { title: '车型论坛', icon: 'dollar', isMenuShow: true, permission: 'com:carforum' },
        },
        {
            path: '/community/carForum/regionalForum',
            name: 'BaseForm',
            component: () => import('../views/community/forumDir/regionalForum'),
            meta: { title: '地区论坛', icon: 'dollar', isMenuShow: true, permission: 'com:regionalforum' },
        },
        {
            path: '/community/carForum/forumList',
            name: 'BaseForm',
            hidden: true,
            component: () => import('../views/community/forumDir/forumList'),
            meta: { title: '论坛列表', icon: 'dollar', permission: 'com' },
        },
        
        
    ]
}
